import ReactGA from 'react-ga';

export const initGA = () => {
  ReactGA.initialize('UA-106192702-1');
};
export const logPageView = (path) => {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
};



// WEBPACK FOOTER //
// ./src/common/utils/analytics.js